import { style } from '@vanilla-extract/css'

import { getMarginListItems, getPaddingListItem } from '~/styles/mixins/list.css'
import { cssVariables } from '~/styles/variables/cssVariables.css'

export const thumbnailList = style({
  display: 'block',
})

export const thumbnailList_items = style({
  display: 'flex',
  alignItems: 'center',
  margin: getMarginListItems(24),
  flexWrap: 'wrap',
})

export const thumbnailList_item = style({
  padding: getPaddingListItem(24),
})

export const thumbnailList_thumbnail = style({
  background: cssVariables.color.white.hex,
})

export const thumbnailList_image = style({})
